/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';

export enum BaseStorageKeys {
  ClientConfig = 'clientConfig',
  AuthUser = 'AuthUser',
  AuthToken = 'AuthToken',
  CoreToken = 'CoreToken',
  Permissions = 'PermissionObj',
  Client = 'client',
  SuperAdminApiToken = 'superAdminApiToken',
  Cluster = 'cluster',
  SuperAdminClientsSearch = 'superAdminClientsSearch',
  User = 'user',
  UserLoggedDate = 'userLoggedInDate',
  AgingReportSearch = 'AgingReportSearch',
  BillCollectionSearch = 'BillCollectionSearch',
}

export enum PREFIXES {
  ZM = 'zm',
  EMPTY = '',
  SUPER_ADMIN = 'superAdmin',
  ZM_ADMIN = 'zmAdmin',
}

@Injectable({
  providedIn: 'root',
})
export class BaseStorageService {
  remove(key: string, prefix?: string): void {
    localStorage.removeItem(this.prepareKey(key, prefix));
  }

  removeMany(keys: string[], prefix?: string): void {
    keys.forEach((key: string) => localStorage.removeItem(this.prepareKey(key, prefix)));
  }

  set<T>(key: string, data: T, prefix?: string): void {
    localStorage.setItem(this.prepareKey(key, prefix), JSON.stringify(data));
  }

  get<T>(key: string, prefix?: string): T | null {
    const value = String(localStorage.getItem(this.prepareKey(key, prefix)));
    // convert literal null to 'null' when item is not found, JSON.parse() only takes strings
    try {
      return JSON.parse(value);
    } catch {
      return value as any;
      // strings without the quotes will throw an error in JSON.parse()
    }
  }

  private prepareKey(key: string, prefix: string = PREFIXES.SUPER_ADMIN): string {
    return (prefix && `${prefix}_${key}`) || key;
  }
}
